import Notify from 'klicknotify';
import * as types from './types';
import * as stepTypes from '../step/types';
import Box from '../../../helpers/request/box';
import router from '../../../router';
import * as internalStyleHelper from '../../../helpers/internalstyle';
import i18n from '../../../i18n';

const locale = i18n.locale;
const messages = i18n.messages[locale];

const BoxRequest = new Box();

export const boxGetAll = ({ commit }) => {
  BoxRequest.get('', { catchError: true })
    .then(response => commit(types.BOX_LIST_SET, response.data));
};

export const boxGet = ({ commit, dispatch, rootState }) => {
  const boxId = rootState.route.params.boxId;

  return BoxRequest.get(boxId, { catchError: true })
    .then(response => {
      const box = response.data;
      commit(types.BOX_ACTIVE_SET, box);
      commit(stepTypes.STEP_UPDATE_QUIZ_ID, box.quiz_id);
      dispatch('quizGet', box.quiz_id);
      dispatch('themeGet', box.theme_slug);

      return box;
    });
};

export const boxSetActive = ({ commit }, box) => {
  commit(types.BOX_ACTIVE_SET, box);
};

export const boxSetKind = ({ rootState, dispatch, commit }, type) => {
  const boxId = rootState.route.params.boxId;

  BoxRequest.put(boxId, { kind: type }, { showLoader: true })
    .then(() => {
      commit(types.BOX_ACTIVE_UPDATE_KIND, type);
      dispatch('sidebarChangePanel', 'themes');
    });
};

export const boxSetFormat = ({ rootState, dispatch, commit }, format) => {
  const boxId = rootState.route.params.boxId;

  BoxRequest.put(boxId, { format }, { showLoader: true })
    .then(() => {
      const nextPanel = format === 'component' ? 'themes' : 'viewmode';

      commit(types.BOX_ACTIVE_UPDATE_FORMAT, format);
      dispatch('sidebarChangePanel', nextPanel);
    });
};

export const boxSetName = ({ commit, rootState }, event) => {
  const boxId = rootState.route.params.boxId;
  const name = event.currentTarget.value;

  BoxRequest.put(boxId, { name }, { showLoader: true })
    .then(() => commit(types.BOX_ACTIVE_UPDATE_NAME, name));
};

export const boxSave = ({ state, rootState }, publish) => {
  const boxId = rootState.route.params.boxId;
  const box = state.active;

  box.publish = publish;

  return BoxRequest
    .put(boxId, box)
    .then(() => Notify.success({
      message: 'Box salvo com sucesso!',
      autoHide: true,
    }))
    .catch(() => Notify.error({
      message: 'Não foi possível salvar o box. Tente novamente.',
      autoHide: true,
    }));
};

export const boxesSetName = ({ commit }, data) => {
  BoxRequest.put(data.id, { name: data.event.target.value })
    .then(response => commit(types.BOX_LIST_UPDATE_NAME, response.data));
};

export const boxesDelete = ({ commit, state, dispatch }) => {
  const box = state.active;

  BoxRequest.delete(box.id)
    .then(() => {
      commit(types.BOX_LIST_REMOVE, box);
      dispatch('modalClose');
    });
};

export const boxAdd = () => {
  const newBox = {
    name: messages.general.labels.new_box,
    kind: null,
    content_body: '<div id="klickbox-quiz-canvas"></div>',
    config: {
      trigger_button: {
        style: {
          backgroundColor: '#44B3F2',
          color: '#fff',
          borderRadius: '5px',
          width: '250px',
        },
        kind: 'basic',
        text: 'Responda nossa pesquisa',
      },
      progressbar: {
        kind: 'standard',
        svg: {
          bullet: '<svg></svg>',
          bar: '<svg></svg>',
        },
        step: 0,
      },
      advanced: {
        view_mode: 'click',
        exibition_mode: 'immediately',
        exibition_mode_time_value: 5,
        exibition_mode_scroll_value: 50,
        exibition_frequency: 'until_action',
        exibition_frequency_times_value: 3,
        exibition_frequency_interval_value: 3,
      },
    },
  };

  BoxRequest.post(newBox)
    .then(response => {
      const boxId = response.data.id;

      router.push({
        name: 'boxEdit',
        params: {
          locale: i18n.locale,
          boxId,
        },
      });
    });
};

export const boxSetTheme = ({ commit }, data) => {
  BoxRequest.put(data.id, { theme_slug: data.theme_slug, theme_fonts: data.theme_fonts })
    .then(response => {
      commit(types.BOX_ACTIVE_UPDATE_THEME_SLUG, response.data);
      commit(types.BOX_ACTIVE_UPDATE_THEME_FONTS, response.data);
    });
};

export const boxResetActive = ({ commit }) => {
  commit(types.BOX_ACTIVE_RESET);
};

export const boxUpdateConfig = ({ commit, state }, { item, key, value }) => {
  const config = state.active.config;

  commit(types.BOX_UPDATE_CONFIG, { item, key, value });

  BoxRequest.put(state.active.id, { config }, { showLoader: true })
    .then(response => commit(types.BOX_SET_CONFIG, response.data.config))
    .catch(() => commit(types.BOX_SET_CONFIG, config));
};

export const boxUpdateConfigStyle = ({ commit, state }, { item, rule, value }) => {
  const config = state.active.config;

  commit(types.BOX_UPDATE_CONFIG_STYLE, { item, rule, value });

  BoxRequest.put(state.active.id, { config }, { showLoader: true })
    .then(response => commit(types.BOX_SET_CONFIG, response.data.config))
    .catch(() => commit(types.BOX_SET_CONFIG, config));
};

export const boxPreviewConfigStyleChange = ({ commit }, { item, rule, value }) => {
  commit(types.BOX_UPDATE_CONFIG_STYLE, { item, rule, value });
};

export const boxUpdateContentBody = ({ commit, state }, styles) => {
  const styleTag = internalStyleHelper.getHtmlTag(styles);
  const contentBody = `${styleTag}<div id="klickbox-quiz-canvas"></div>`;

  BoxRequest.put(state.active.id, { content_body: contentBody }, { showLoader: true })
    .then(response => commit(types.BOX_UPDATE_CONTENT_BODY, response.data.content_body));
};

export const updateKlickpagesHeaderShowStatus = ({ commit }, data) => {
  commit(types.KLICKPAGES_HEADER_ACTIVE, data);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/box/actions.js
 **/